import { render, staticRenderFns } from "./ViewItems.vue?vue&type=template&id=53f79ddc&scoped=true"
import script from "./ViewItems.vue?vue&type=script&lang=js"
export * from "./ViewItems.vue?vue&type=script&lang=js"
import style0 from "./ViewItems.vue?vue&type=style&index=0&id=53f79ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f79ddc",
  null
  
)

export default component.exports